import Ajax from '../web/Ajax';
import DatatablesUtils from './DatatablesUtils';
import DatatablesActionTypes from './DatatablesActionTypes';
import ContentType from '../web/ContentType';

class DatatablesCallbacks2 {
    constructor(options) {
        this._selectUrl = options.selectUrl;
        this._createUrl = options.createUrl;
        this._editUrl = options.editUrl;
        this._removeUrl = options.removeUrl;
        this._token = options.token;
    }

    select(data, successCallback, settings) {
        let that = this;

        function returnCallback(newToken) {
            that._token = newToken;
            that.select(data, successCallback, settings);
        }

        // Criando esta função para não usar DatatablesUtils.getCallbackForSuccess
        // e ter que imprimir o campo data que pode ser gigantesco
        function success(data) {
            DatatablesUtils.dispatchAsync({
                type: DatatablesActionTypes.DATATABLE_SELECT_FINISH,
            }).then(() => {
                successCallback(data);
            });
        }

        let url = that._selectUrl;

        DatatablesUtils.dispatchAsync({
            type: DatatablesActionTypes.DATATABLE_SELECT_START,
            url,
            token: that._token
        }).then(() => {
            Ajax.getAsync(url, null, ContentType.FORM, that._token.access_token)
                .then(success)
                .catch(DatatablesUtils.getCallbackForCheckAndUpdateToken(that._token, returnCallback))
                .catch(DatatablesUtils.getSimpleCallbackForFail(DatatablesActionTypes.DATATABLE_SELECT_FAILED));
        });
    }

    create(obsoleteMethod, obsoleteUrl, data, successCallback, errorCallback) {
        let that = this;

        function returnCallback(newToken) {
            that._token = newToken;
            that.create(obsoleteMethod, obsoleteUrl, data, successCallback, errorCallback);
        }

        let url = that._createUrl;

        DatatablesUtils.dispatchAsync({
            type: DatatablesActionTypes.DATATABLE_CREATE_START,
            url,
            token: that._token,
            data
        }).then(() => {
            Ajax.postAsync(url, data, ContentType.FORM, that._token.access_token)
                .then(DatatablesUtils.getCallbackForSuccess(successCallback, DatatablesActionTypes.DATATABLE_CREATE_FINISH))
                .catch(DatatablesUtils.getCallbackForCheckAndUpdateToken(that._token, returnCallback))
                .catch(DatatablesUtils.getComplexCallbackForFail(successCallback, errorCallback, DatatablesActionTypes.DATATABLE_CREATE_FAILED));
        });
    }

    edit(obsoleteMethod, obsoleteUrl, data, successCallback, errorCallback) {
        let that = this;

        function returnCallback(newToken) {
            that._token = newToken;
            that.edit(obsoleteMethod, obsoleteUrl, data, successCallback, errorCallback);
        }

        let id = DatatablesUtils.getId(data);
        let url = DatatablesUtils.replaceId(that._editUrl, id);

        DatatablesUtils.dispatchAsync({
            type: DatatablesActionTypes.DATATABLE_EDIT_START,
            url,
            token: that._token,
            data
        }).then(() => {
            Ajax.postAsync(url, data, ContentType.FORM, that._token.access_token)
                .then(DatatablesUtils.getCallbackForSuccess(successCallback, DatatablesActionTypes.DATATABLE_EDIT_FINISH))
                .catch(DatatablesUtils.getCallbackForCheckAndUpdateToken(that._token, returnCallback))
                .catch(DatatablesUtils.getComplexCallbackForFail(successCallback, errorCallback, DatatablesActionTypes.DATATABLE_EDIT_FAILED));
        });
    }

    remove(obsoleteMethod, obsoleteUrl, data, successCallback, errorCallback) {
        let that = this;

        function returnCallback(newToken) {
            that._token = newToken;
            that.remove(obsoleteMethod, obsoleteUrl, data, successCallback, errorCallback);
        }

        let id = DatatablesUtils.getId(data);
        let url = DatatablesUtils.replaceId(that._removeUrl, id);

        DatatablesUtils.dispatchAsync({
            type: DatatablesActionTypes.DATATABLE_REMOVE_START,
            url,
            token: that._token
        }).then(() => {
            Ajax.postAsync(url, null, ContentType.FORM, that._token.access_token)
                .then(DatatablesUtils.getCallbackForSuccess(successCallback, DatatablesActionTypes.DATATABLE_REMOVE_FINISH))
                .catch(DatatablesUtils.getCallbackForCheckAndUpdateToken(that._token, returnCallback))
                .catch(DatatablesUtils.getComplexCallbackForFail(successCallback, errorCallback, DatatablesActionTypes.DATATABLE_REMOVE_FAILED));
        });
    }
}

export default DatatablesCallbacks2;



// WEBPACK FOOTER //
// src/datatables/DatatablesCallbacks.js